<template>
    <div class="integralManagement">
        <div>
            <div class="orderSearchBox">
                <div class="searchItem">
                    <el-input v-model="form.storeName" placeholder="店铺名称"></el-input>
                </div>
                <div class="searchItem">
                    <el-input v-model="form.username" placeholder="商家账号"></el-input>
                </div>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <!-- 排序 -->
            <div class="sorting">
                <el-radio-group v-model="checkboxGroup.radio1" size="small" @change="findInfo">
                        <el-radio-button label="available_points">
                            <p>现有积分</p>
                            <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'available_points'"></i>
                            <i class="el-icon-top" v-else></i>
                        </el-radio-button>
                        <el-radio-button label="consume_points">
                            <p>兑换积分</p>
                            <i class="el-icon-bottom" v-if="checkboxGroup.radio1 == 'consume_points'"></i>
                            <i class="el-icon-top" v-else></i>
                        </el-radio-button>
                    </el-radio-group>
        <span  style="margin-left: 20px"
        >已选： <span class="num">{{ num }}</span></span
        >
                <el-button type="primary" plain size="small" @click="publishSubmit"
                >批量导出
                </el-button
                >
            </div>
            <div class="orderListTable">
                <el-table
                    :data="tableData"
                    border
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    class="tableContent"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        prop="storeName"
                        label="店铺名称"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="username"
                        align="center"
                        header-align="center"
                        label="商家账号"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="availablePoints"
                        align="center"
                        header-align="center"
                        label="现有积分"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="consumePoints"
                        align="center"
                        header-align="center"
                        label="兑换积分"
                    >
                    </el-table-column>
                    <el-table-column header-align="center" align="center" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="consumePoints(scope.row)" v-if="scope.row.availablePoints > 0"
                            >兑换
                            </el-button
                            >
                            <el-button type="text" size="small" @click="handleIntegralDetails(scope.row)"
                            >查看
                            </el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total"
                    class="pagination"
                >
                </el-pagination>
                <el-dialog
                    title="查看"
                    :close-on-click-modal="false"
                    :visible.sync="dialogyDateVisible"
                    append-to-body
                    class="dialogActivityDateVisible"
                >
                    <div class="dialogContent">
                        <div class="titleTop">商家积分信息</div>
                        <div class="dialogContent_box">
                            <div class="box_mess">
                                <p>商家账号：</p>
                                <p>{{ username }}</p>
                            </div>
                            <div class="box_mess">
                                <p>现有积分：</p>
                                <p>{{ availablePoints }}</p>
                            </div>
                        </div>
                        <div class="titleTop">积分记录</div>
                        <el-table
                            :data="tableDataList"
                            border
                            style="width: 100%"
                            class="tableContent"
                        >
                            <el-table-column
                                prop="createTime"
                                label="兑换日期"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="consumePoints"
                                label="兑换积分"
                                header-align="center"
                                show-overflow-tooltip
                                align="center"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        uploadFile,
        activitiesListByPage,
        activitiesList,
        getActivitiesDetails,
        saveActivities,
        publishActivities,
        delActivities,
        activitiesStoreListByPage,
        activitiesStoreList,
        activitiesGoodsListByPage,
        activitiesGoodsList,
        getActivitiesGoodsDetails,
        auditActivitiesGoods,
        activitiesStorePointListByPage,
        activitiesStorePointList,
        exchangeActivitiesStore
    } from "../../utils/interface";
    export default {
        name: "integralManagement",
        data() {
            return {
                activityUuid: "",
                username: "",
                availablePoints: "",
                form: {
                    storeName: "",
                    username: "",
                },
                num: 0,
                multipleSelection: [],
                tableData: [
                ],
                current: 1,
                pageSize: 10,
                total: 0,
                dialogyDateVisible: false,
                tableDataList: [
                ],
                // 排序
                checkboxGroup: {
                    radio1: '0',
                },
            };
        },
        mounted() {
            if(this.$route.params.data){
                this.form.activityUuid = this.$route.params.data.uuid;
                this.form.activityName = this.$route.params.data.activityName;
            }
            this.search();
        },
        methods: {
            findInfo(){
                this.form.sort = this.checkboxGroup.radio1;
                this.form.order = "desc";
                this.search();
            },
            search() {
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.activityType = 'INTEGRAL';
                activitiesStorePointListByPage(this.form).then((res)=>{
                    if(res.success) {
                        this.tableData = [];
                        this.total = res.data.total;
                        this.tableData = res.data.list
                    }
                });
            },
            resetData() {
                this.form.storeName = "";
                this.form.username = "";
                this.search();
            },
            handleSelectionChange(val) {
                this.num = val.length;
            },
            publishSubmit() {
                if(this.num==0){
                    this.$message.error("请选择要导出的数据");
                    return
                }
                this.multipleSelection.forEach((item, index) => {
                    if(item.activityGoodsSpecInfoList.length > 0){
                        let goodsSpec = "";
                        item.activityGoodsSpecInfoList.forEach((item1, index) => {
                            goodsSpec = goodsSpec + "规格名称: " + item1.goodsSpecName + " 商品价格: " + item1.goodsPrice + " 兑换积分: " + item1.goodsIntegral  + ";";
                        });
                        item.goodsSpec = goodsSpec;
                    }
                });
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../static/js/Export2Excel');//注意这个Export2Excel路径
                    const tHeader = ['店铺名称', '商家账号', '现有积分'];   // 上面设置Excel的表格第一行的标题
                    const filterVal = ['storeName', 'username', 'availablePoints']; // 上面的index、nickName、name是tableData里对象的属性key值
                    const list = this.multipleSelection;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '商家积分管理');//最后一个是表名字
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            handleCurrentChange(val) {
                this.current = val
                this.search();
            },
            // 兑换
            consumePoints(val) {
                this.$confirm('确定要兑换当前商家的积分么？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    exchangeActivitiesStore({storeUuid:val.storeUuid, consumePoints: val.availablePoints}).then((res)=>{
                        if(res.success){
                            this.$message.success("积分兑换成功");
                        }else{
                            this.$message.error("数据异常，积分兑换失败，请稍后再试");
                        }
                        this.search();
                    });
                });
            },
            handleIntegralDetails(val) {
                this.availablePoints = val.availablePoints;
                this.username = val.username;
                this.tableDataList = val.activityStorePointRecordList;
                this.dialogyDateVisible = true;
            },
        },
    };
</script>

<style lang="less" scoped>
    .integralManagement {
        background: #fff;
        margin: 0 20px 20px;
        padding: 20px;

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 20px;

            /deep/ .el-input {
                width: initial;
                // margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
            }

            .resetBtn {
                color: #333333;
            }

            .searchItem {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .name {
                    padding-right: 20px;
                    min-width: 100px;
                }
            }

            .searchItem_time {
                margin-right: 20px;

                /deep/ .el-input__inner {
                    width: 292px;
                }
            }
        }

        .tableContent {
            min-height: 650px;

            /deep/ .el-table__header {
                tr {
                    th {
                        border-right: none;
                    }
                }

                /deep/ .el-table__cell {
                    padding: 5px 0;
                    background: #f2f5fc;
                }
            }

            /deep/ .el-table__body {
                img {
                    vertical-align: middle;
                    width: 52px;
                    height: 50px;
                }
            }
        }

        .pagination {
            margin-top: 20px;
            text-align: right;
        }

        .sorting {
            margin-bottom: 10px;
            font-size: 14px;

            span {
                margin-right: 15px;
            }
                    p {
            margin: 0;
        }
        /deep/.el-radio-button--small .el-radio-button__inner {
           display: flex;
           align-items: center;
        }
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            background-color: #3d7fff;
        }
        }
    }

    .dialogActivityDateVisible {
        .titleTop {
            font-size: 20px;
            margin-bottom: 26px;
            padding-left: 48px;
            border-top: 1px solid #efefef;
            padding-top: 30px;

            &:nth-of-type(1) {
                border-top: none;
                padding-top: 0;
            }
        }

        .dialogContent_box {
            display: flex;
            flex-wrap: wrap;
            margin: 0 50px;

            .box_mess {
                width: 50%;
                display: flex;
                margin-bottom: 15px;

                img {
                    width: 300px;
                    height: 150px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/integral/merchantsIntegralManagement.vue